import React, { useState } from 'react'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { ViewAgendaOutlined, ViewStreamOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import useStore from '../../helpers/useStore';
import { CalendarContext } from '../../stores/Calendar/calendar.provider';

interface GroupCheckBoxProps {
  onChecked?: (checked: boolean) => void;
  checked?: boolean;
}

const GroupCheckBox = ({ onChecked, checked:checked_ }: GroupCheckBoxProps) => {

  const CalendarStore = useStore(CalendarContext);
  const { groupCheck:groupCheckFromStore, setGroupCheck } = CalendarStore;


  const checked = checked_ !== undefined ? checked_ : groupCheckFromStore;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setGroupCheck(event.target.checked);
    return onChecked && onChecked(event.target.checked);
  };

  return (
    <Tooltip title={checked ? "Termine gruppieren" : "Termine nicht gruppieren"}>
      <Checkbox
        checked={checked}
        onChange={handleChange}
        inputProps={{ 'aria-label': 'group timeslots' }}
        icon={<ViewAgendaOutlined sx={{ fontSize: 20 }} />}      // unchecked
        checkedIcon={<ViewStreamOutlined sx={{ fontSize: 20 }} />} // checked
        sx={{
          backgroundColor: 'white',
          borderRadius: 1,
          border: '1px solid rgba(0, 0, 0, 0.15)',
          '&:hover': {
            backgroundColor: 'white',
          },
          '&.Mui-focusVisible': {
            backgroundColor: 'white',
          },
          // Match the toolbar's 32px control height discipline.
          height: 32,
          width: 32,
        }}
      />
    </Tooltip>
  );
}

export default GroupCheckBox